export default __webpack_public_path__ + "static/media/rhino.17c0f6cb.svg";